/* Zombie — Build a Bundle, Route A (19 Oct 2026): VIEW BUNKER on phones / tablets.
   Below 1024px Appstle's own summary bar is a compact bar fixed to the bottom
   (assets/zombie-bundle-builder.css). This only adds a theme button + scrim
   OUTSIDE Appstle's markup and toggles html.zbab-sheet-open, which opens that
   same Appstle bar as a sheet. It reads no bundle data, creates no summary and
   never touches Appstle's DOM — Appstle stays the source of truth. */
(() => {
  const OPEN = 'zbab-sheet-open';
  const mobile = window.matchMedia('(max-width: 1023px)');
  const root = document.documentElement;
  let toggle;
  let scrim;

  const isOpen = () => root.classList.contains(OPEN);
  const setOpen = (open, { focus = true } = {}) => {
    root.classList.toggle(OPEN, open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Close' : 'View bunker';
    toggle.setAttribute('aria-label', open ? 'Close your bunker' : 'View your bunker');
    if (focus) toggle.focus();
  };

  const build = () => {
    if (toggle) return;
    toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'zbab-toggle';
    toggle.setAttribute('aria-controls', 'dynamic-pricing-bundle-custom-page');
    scrim = document.createElement('div');
    scrim.className = 'zbab-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    document.body.append(scrim, toggle);
    setOpen(false, { focus: false });
    toggle.addEventListener('click', () => setOpen(!isOpen()));
    scrim.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) setOpen(false);
    });
    mobile.addEventListener('change', (event) => {
      if (!event.matches && isOpen()) setOpen(false, { focus: false });
    });
  };

  // Appstle renders its builder client-side; add the button once its bar exists.
  const ready = () => document.querySelector('#ab-dynamic-pricing-bundle .ab-tiered-discount-progress-step-container');
  const start = () => {
    if (ready()) return build();
    const observer = new MutationObserver(() => {
      if (ready()) {
        observer.disconnect();
        build();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
